module.exports = "<div class=\"test-page\">\n\t<h1>This is a Test Page</h1>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/test/test-page/test-page.component.html
// module id = ./src/app/test/test-page/test-page.component.html
// module chunks = main